import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import isHttpWithHttps, {
  isHttpWithHttpsNotification,
} from './isHttpWithHttps';
import * as hereOidc from "@here/oidcha-sdk";
import get from 'lodash/get';
import { ENV } from '../../../configs/config';

const getLocalStorageKey = (appId) => `hereTokenSettings.v1.${appId}`;

const params = {
  'dev': {
    clientId: 'DRmVbpPYk12eDc61QI47',
    realm: 'olp-here',
    redirectUri: window.location.origin,
    environment: 'https://st.p.account.here.com/',
    accountUserinfo: `https://st.p.account.here.com/openid/userinfo`,
    logoutUrl: `https://st.p.account.here.com/logout`,
    apiEndpoint: `https://stg.account.api.here.com`,
    platformServices: 'https://registry.services.api.platform.in.here.com'
  },
  'dev-sk': {
    clientId: 'DRmVbpPYk12eDc61QI47',
    realm: 'olp-here',
    redirectUri: window.location.origin,
    environment: 'https://st.p.account.here.com/',
    accountUserinfo: `https://st.p.account.here.com/openid/userinfo`,
    logoutUrl: `https://st.p.account.here.com/logout`,
    apiEndpoint: `https://stg.account.api.here.com`,
    platformServices: 'https://registry.services.api.platform.in.here.com'
  },
  'prd': {
    clientId: 'G0LhWBGMKIdoEOA9ZUN8',
    realm: 'org903589868',
    redirectUri: window.location.origin,   
    environment: 'https://account.here.com/',
    accountUserinfo: `https://account.here.com/openid/userinfo`,
    logoutUrl: `https://account.here.com/logout`,
    apiEndpoint: `https://account.api.here.com`,
    platformServices: 'https://registry.services.api.platform.here.com'
  },
  'prd-sk': {
    clientId: 'G0LhWBGMKIdoEOA9ZUN8',
    realm: 'org903589868',
    redirectUri: window.location.origin,   
    environment: 'https://account.here.com/',
    accountUserinfo: `https://account.here.com/openid/userinfo`,
    logoutUrl: `https://account.here.com/logout`,
    apiEndpoint: `https://account.api.here.com`,
    platformServices: 'https://registry.services.api.platform.here.com'
  }
}
let sdk = null;

class PlatformCredentialSettings extends React.Component {
  state = {
    isTokenLoading: false
  };
  
  getInitToken = async () => {
    const { onChange, authEndpoint, consumerScope, title } = this.props;
    const remoteCreds = await getToken({authEndpoint, consumerScope}, title, true);
    if (remoteCreds) {
      onChange(remoteCreds);
    }
    
    const projectsList = getProjectsListFromLocalStorage(`${authEndpoint}-projectsList`);
    if (projectsList) {
      onChange(projectsList);
    }
  }

  componentDidMount() {
    this.getInitToken()
  }

  onChange(key, { target: { value } }) {
    if (isHttpWithHttps(value)) {
      const { setNotification } = this.props;
      isHttpWithHttpsNotification(setNotification);
    }
    this.props.onChange({ [key]: value });
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

PlatformCredentialSettings.propTypes = {
  isCustom: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string,
  consumerScope: PropTypes.string,
  token: PropTypes.string,
  tokenExpiry: PropTypes.number,
  authEndpoint: PropTypes.string,
  setNotification: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps() {
  return {
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  parseUrl: () => ({}),
  getDisplayUrl,
  preFetch,
  getToken,
  listProjects,
  signOut,
  getUserInfo,
  getUserCatalogInfo,
  getRequestOptions: (settings, fieldParams) => {
    return {
      url: getDisplayUrl(settings, fieldParams).split('?')[0],
      headers: {
        Authorization: `Bearer ${settings.token}`,
      },
    };
  },
  Component: connect(mapStateToProps, mapDispatchToProps)(PlatformCredentialSettings),
};

function getoidcConfig(env) {
  return  {
    clientId: params[env].clientId,
    environment: params[env].environment,
    prompt: "login",
    currentWindow: true,
    responseType: "id_token token",
    scope: "openid email phone profile readwrite:ha",
    nonce: new Date().getTime(),
    maxAge: "1209600",
    // noSignUp: false,
    realm: params[env].realm,
    realmInput: false,
    openSignUp: false,
    onlySignUp: false,
    noSignUp: true,
    noClmSignUp: true,
    selfCertifyAge: false,
    inviteToken: "",
    uatDuration: "1209600",
    realmAny: false,
    prefillEmailAddr: "",
    signInTemplate: ['prd','prd-sk'].includes(env) ? "harmony" : "olp",
    redirectUri: params[env].redirectUri,
    signInScreenConfig: ["password"],
    callback: (err, data) => {
      if (err) {
            new Error(err);
            return;
        }
        // your callback implementation
        return data.token;
    }
  };
}

function oidcAuth(env) {
  localStorage.clear();
  const config = getoidcConfig(env);
  sdk = hereOidc.Account.Openid(config);
  sdk.oidcAuthorize();
}

/**
 * Enhanced sign out function with comprehensive cleanup (no clearAccessToken call)
 * @param {boolean} signInAfter - Whether to sign in again after logout
 * @param {string} authEndpoint - Authentication endpoint
 */
async function signOut(signInAfter = true, authEndpoint) {
  try {
    const config = getoidcConfig(ENV);
    sdk = hereOidc.Account.Openid(config);
    
    // Use 'forceLogout' for complete session termination
    const clearType = 'forceLogout';
    
    const callback = async function (status) {
      console.log("SDK clearCookies returned: " + status);
      
      try {
        // 2. Clear sessionStorage
        sessionStorage.clear();
        localStorage.setItem(
          getLocalStorageKey(authEndpoint),
          '{}'
        );
        
        // 4. Final cleanup and redirect (no server token clearing)
        finalizeLogout(signInAfter, ENV);
        
      } catch (error) {
        console.error('Error during logout cleanup:', error);
      }
    };
    
    // Execute SDK sign out
    sdk.oidcSignOut(clearType, signInAfter, callback);
    
  } catch (error) {
    console.error('Sign out initiation failed:', error);
  }
}


/**
 * Finalize logout process
 * @param {boolean} signInAfter - Whether to sign in after logout
 * @param {string} env - Environment identifier
 */
function finalizeLogout(signInAfter, env) {
  try {
    if (signInAfter) {
      // Small delay to ensure cleanup is complete
      setTimeout(() => {
        console.log('Redirecting to sign in...');
        oidcAuth(env);
      }, 1000);
    } else {
      // Navigate to clean state
      setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname;
      }, 500);
    }
  } catch (error) {
    console.error('Failed to finalize logout:', error);
    // Force reload as last resort
    window.location.reload();
  }
}

function getDisplayUrl(settings, fieldRequestOptions) {
  const { pathParams = {} } = fieldRequestOptions;
  const url = Object.keys(pathParams).reduce(
    (acc, paramKey) =>
      acc.replace(new RegExp(`{${paramKey}}`, 'g'), pathParams[paramKey]),
    settings.url
  );
  return decodeURIComponent(
    axios.getUri({ url: url || '', ...fieldRequestOptions })
  );
}

async function listProjects(token, authEndpoint) {
  const configHeader = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.get(`${params[ENV].apiEndpoint}/authorization/v1.1/projects/me?isMember=true`, configHeader).then(response => {
    const items = response.data.items;
    if( items ) {
      const projects = items.map(item => { 
        const { name, hrn } = item; 
        return { label: name, value: hrn }
      });

      localStorage.setItem(
        getLocalStorageKey(`${authEndpoint}-projectsList`),
        JSON.stringify(projects)
      );
      return projects;
    }
    else return [];
  }).catch(error => { return error.response;});
}

async function getUserInfo(accessToken) {
  try{
    const configHeader = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
  
    const res = await axios
      .get(params[ENV].accountUserinfo, configHeader);
      
    return {
      ...res.data,
      userToken: accessToken,
    };
  } catch (e) {
    console.error(e);
    oidcAuth(ENV);
  }
}

async function getUserCatalogInfo(accessToken,url) {
  try {
    const configHeader = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    
    const res = await axios
      .get(`${url}/currentuser`, configHeader);
    return {
      ...res.data,
    };
  } catch (e) {
    console.error(e);
  }
}

async function getToken(settings, title, localStorageConsumerScope) {
  let { authEndpoint = '' } = settings;
  const {scopes, token, tokenExpiry } = getCredsFromLocalStorage(authEndpoint) || {};
  let { consumerScope } = localStorageConsumerScope ? get(scopes, title, {}) : settings;
  // const { consumerScope } = localStorageConsumerScope ? getCredsFromLocalStorage(authEndpoint)||{} : settings;
  
  if(token){
    if(tokenExpiry && +tokenExpiry < (new Date()).getTime() ){
      // Token has expired
      localStorage.removeItem(getLocalStorageKey(authEndpoint));
      localStorage.removeItem(getLocalStorageKey(`${authEndpoint}-projectsList`));
      return signOut(token,authEndpoint);
    }
     return {
        token,
        tokenExpiry,
        scopedToken: '',
        scopedTokenExpiry: '',
        consumerScope: '',
        projectScope:  '',
      };
  }

  let tokenSet = {};

  try {
    const urlHash = window.location.hash.substring(1);
      const hashParams = new URLSearchParams(urlHash);
      const accessToken = hashParams.get('access_token');
      const expiresIn = hashParams.get('expires_in');
      const currentTime = Date.now();
      const expiryTime = currentTime + (parseInt(expiresIn) * 1000);

    const scope = '';
    
    tokenSet = {
      token: accessToken,
      tokenExpiry: expiryTime,
      scopes: {
        ...scopes, 
        [title]: {
          scopedToken: '',
          scopedTokenExpiry: '',
          consumerScope: consumerScope,
          projectScope: scope || '',
        }
      }
    };
    window.location.hash = '';
    localStorage.setItem(
      getLocalStorageKey(authEndpoint),
      JSON.stringify(tokenSet)
    );
    return {
      token: accessToken,
      tokenExpiry: expiryTime,
      scopedToken: '',
      scopedTokenExpiry: '',
      consumerScope: consumerScope,
      projectScope: scope || '',
    };
  } catch (e) {
    console.error(e);
    if (authEndpoint !== '')
      oidcAuth(ENV);
    else return;
  }
}

async function preFetch(settings, title, getRemote) {
  const { token, tokenExpiry, authEndpoint = '', scopedToken, scopedTokenExpiry } =
    settings;

  const currTime = new Date().getTime();
  if (!getRemote && scopedToken && +scopedTokenExpiry > currTime) {
    return {token: scopedToken, tokenExpiry: scopedTokenExpiry, projectScope: settings.projectScope};
  }
  if (!getRemote && token && +tokenExpiry > currTime) {
    return {};
  }

  const creds = getCredsFromLocalStorage(authEndpoint, title) || {};
  const { projectScope, consumerScope } = creds;
  if (!getRemote && creds && creds.scopedToken && +creds.scopedTokenExpiry > currTime) {
    return { token: creds.scopedToken, tokenExpiry: creds.scopedTokenExpiry, projectScope, consumerScope };
  }
  if (!getRemote && creds && creds.token && +creds.tokenExpiry > currTime) {
    return creds;
  }

  const tokenSet = await getToken(settings, title);
  return tokenSet;
}

function getCredsFromLocalStorage(authEndpoint, title) {
  const credsStr = localStorage.getItem(getLocalStorageKey(authEndpoint));
  if (credsStr) {
    try {
      const creds = JSON.parse(credsStr);
      if (creds.token && creds.tokenExpiry) {
        if (!title) {
          return {
            token: creds.token,
            tokenExpiry: creds.tokenExpiry,
            scopes: creds.scopes || {}
          };
        } else {
          const scopes = creds.scopes[title] || {};
          return {
            token: creds.token,
            tokenExpiry: creds.tokenExpiry,
            scopedToken: scopes.scopedToken,
            scopedTokenExpiry: scopes.scopedTokenExpiry,
            consumerScope: scopes.consumerScope,
            projectScope:  scopes.projectScope
          };
        }
      }
    } catch (e) {
      // ignore exception
    }
  }

  return null;
}

function getProjectsListFromLocalStorage(authEndpoint) {
  const listStr = localStorage.getItem(getLocalStorageKey(authEndpoint));
  if (listStr) {
    try {
      const list = JSON.parse(listStr);
      return {
        projectsList: list
      };
    } catch (e) {
      // ignore exception
    }
  }

  return null;
}
